// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

import ahoy from "ahoy.js"

const ahoySkip = () => !!document.querySelector('meta[name="ahoy-skip"]')

if (ahoySkip()) ahoy.configure({ trackVisits: false })
ahoy.configure({ visitDuration: 240 })
document.addEventListener("turbo:load", () => { if (!ahoySkip()) ahoy.trackView() })
